import { FolderMultipleOutlineIcon } from './FolderMultipleOutlineIcon';

/**
 * author: Austin Andrews
 * id F91AD38D-33E3-46A4-83BC-17B671750D6C
 * name folder-multiple-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-multiple-outline.svg
 * tags
 * - Files / Folders 
 */
export const FoldersOutlineIcon = FolderMultipleOutlineIcon;
export default FoldersOutlineIcon